import React, { Fragment } from "react";
import "./VulReport.css";
import { Dimensions } from '../../Helper/sitedimension';
import Fade from "react-reveal/Fade";

const Vulsection = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    width > 500 ?
      <Fragment>
        <div className="container-fluid cch vulwrap d-flex flex-column website-test">
          <div className="row">
            <div className="col-12">
              <div className="rc">
                <Fade delay={300} top>
                  <h1
                    className="main-text"
                  >
                    Are you a Security Researcher?
              </h1>
                </Fade>
                <Fade delay={600} top>
                  <h3 className="content">
                  Become a part of our largest Security Researcher Community 

                </h3>
                </Fade>
                <button type="button" className="btn btn-outline-white" id="butt">
                  <span className="btn-content">Get Started</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment > : <Fragment>
        <div className="container-fluid cchmob vulwrap d-flex flex-column website-testmob">
          <div className="row">
            <div className="col-12">
              <div className="rc">
                <Fade delay={300} top>
                  <h1
                    className="main-text"
                  >
                    Are you A security Researcher ?
              </h1>
                </Fade>
                <Fade delay={600} top>
                  <h3 className="content">
                    Let's Get start with Bug Bounty Program
                </h3>
                </Fade>
                <button type="button" className="btn btn-outline-white" id="butt">
                  <span className="btn-content">Get Started</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment >
  );
};

export default Vulsection;
